import { Component, OnInit } from '@angular/core';
import { faCaretRight, faEnvelope } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'nl-contact',
  templateUrl: './contact.component.html',
  styleUrls: []
})
export class ContactComponent implements OnInit {

  faCaretRight = faCaretRight;
  faEnvelope = faEnvelope;

  constructor() { }

  ngOnInit() {
  }

}
